import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=89b7e158&scoped=true&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=89b7e158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b7e158",
  null
  
)

export default component.exports